import router from "@/router";
import utils from "@/utils";
import localRouterList from "@/router/local_routers"

const state = {
  menu: JSON.parse(sessionStorage.getItem("menu")) || [], // 主菜单
  menuActive: sessionStorage.getItem("menuActive") || "/", // 激活主菜单
  menuOpened: sessionStorage.getItem("menuOpened") || "", // 展开子菜单
  routes: !!sessionStorage.getItem("menu") ,// 动态路由添加状态
  flags: [],
  local_routers: localRouterList,
  navs: []
};

const getters = {
  getMenu: state => state.menu,
  getMenuActive: state => state.menuActive,
  getMenuOpened: state => state.menuOpened,
  getNavs: state =>{
    const userInfo =JSON.parse(sessionStorage.getItem("userInfo"));
    const menu = userInfo["menus"];
    if (menu.length > 0){//从menus 中找到navs
      menu.forEach(item =>{
        if (item.navs && item.navs.length > 0){
          state.navs = item.navs
        }
      })
    }
    return state.navs;
  },
  getFlags: state =>{
    const userInfo =JSON.parse(sessionStorage.getItem("userInfo"));
    const menu = userInfo["menus"];
    let tempFlag = [];
    if (menu.length > 0){
      menu.forEach(item =>{
         if (item.flag && item.flag !== ''){
           tempFlag.push(item.flag)
         }
      })
      state.flags = tempFlag;
    }
    return state.flags;
  }
};

const mutations = {
  // 获取菜单
  MENU: (state, data) => {
    // 判断动态路由是否已添加
    if (!state.routes) {
      // 获取动态路由
      const routes = utils.getRoutes(data);
      // 添加动态路由
      router.options.routes = routes;
      router.addRoutes(routes);
      // 动态路由添加状态
      state.routes = true;
    }

    state.menu = data; // 获取菜单
    sessionStorage.setItem("menu", JSON.stringify(data));
  },
  // 选择菜单
  MENU_SELECT: (state, data) => {
    router.push(data); // 路由跳转
    state.menuActive = data.split("?")[0]; // 激活菜单
    state.menuOpened = `/${data.split("/")[1]}`; // 展开菜单
    sessionStorage.setItem("menuActive", data);
    sessionStorage.setItem("menuOpened", state.menuOpened);
  },
  // 重置菜单
  MENU_RESET: state => {
    state.menu = [];
    state.menuActive = "/";
    state.menuOpened = "";
    sessionStorage.clear();
  }
};

const actions = {
  // 获取菜单
  handleMenu: ({ commit }) => {
    const userInfo =JSON.parse(sessionStorage.getItem("userInfo"));
    const menus = userInfo["menus"];
    let temp = [{
      "id": "1",
      "name": "首页",
      "alias": "管理员首页",
      "url": "/manage/findByPatientId",
      "parentId": 0,
      "sort": 1,
      "flag": "MANAGE",
      "navs": [],
      "authoritys": []
    }]
    menus.forEach(item=>{
      temp.push(item)
    })
    //合并格式化本地路由
    let user_routers = format_routers(temp);
    commit("MENU", user_routers);
    commit("MENU_SELECT", user_routers[0].path);
  }
};

/**
 * 合并请求与本地路由,图标等由本地进行管理
 * @param menu
 * @returns {Array}
 */
function format_routers(menu){
  let routers =[];
  let fncRouters =  state.local_routers;
  for (let i=0; i< menu.length; i++) {
    let userMenu = menu[i];
    for ( let j=0; j < fncRouters.length; j++) {
      if(userMenu.children && fncRouters[j].children && userMenu.url === fncRouters[j].path){
        let res = sumMenuRes(userMenu,fncRouters[j])
        res["children"] = child_iterator(userMenu.children, fncRouters[j].children);
        routers.push(res);
      }else if (userMenu.url === fncRouters[j].path) {
        let res = sumMenuRes(userMenu,fncRouters[j])
        routers.push(res);
      }
    }
  }
  routers[0].path="/";//避免与Layout无法兼容,需要将index为0的路径改为/
  return routers;
}

//格式化子菜单
function child_iterator(userMenu, localMenu){
  let children = [];
  for (let i = 0; i < userMenu.length; i++) {
    let userSub = userMenu[i];
    for (let j = 0; j < localMenu.length; j++) {
      if (userSub.children && localMenu[j].children && userSub.url === localMenu[j].path){
        let res = sumMenuRes(userSub,localMenu[j])
        res["children"] = child_iterator(userSub.children, localMenu[j].children);
        children.push(res);
      } else if (userSub.url === localMenu[j].path) {
        let res = sumMenuRes(userSub,localMenu[j])
        children.push(res);
      }
    }
  }
  return children;
}

function sumMenuRes(userMenu, localMenu){
  return{
    path: localMenu.path,
    icon: localMenu.icon,
    compName: localMenu.compName,
    compPath: localMenu.compPath,
    flag: userMenu.flag,
    name: localMenu['hide'] ? localMenu.alias : userMenu.name
  };
}

export default {
  state,
  getters,
  mutations,
  actions
};
